// extracted by mini-css-extract-plugin
export default {"chartlink":"SubChart_chartlink__OGNsU","chart":"SubChart_chart__0r42h","indexchart":"SubChart_indexchart__cbRnC"};